import { createSelector } from 'reselect'
import { TRAINING_AUTH_DOMAIN } from 'modules/training/modules/app-auth/constants'

function getTrainingAuthSelector (key) {
  return createSelector(
    state => state[TRAINING_AUTH_DOMAIN].changed[key],
    value => value
  )
}

export default getTrainingAuthSelector
